import Vue from "vue";
import App from "./App.vue";
import i18n from "./i18n";
import * as VueGoogleMaps from "vue2-google-maps";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import WebFont from "webfontloader";

Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDfJAYfJ4otGnMAsacPNaMQF90DGu2j_Z4",
    libraries: "places,geocoder",
  },
});

Vue.component("GmapCluster", GmapCluster);

new Vue({
  i18n,
  render: (h) => h(App),
}).$mount("#app");

function detectCurrentSite() {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.has("site") && urlParams.get("site") !== "") {
    document
      .getElementsByTagName("body")[0]
      .classList.add(urlParams.get("site"));

    loadWebFonts(urlParams.get("site"));
  }
}

detectCurrentSite();

function loadWebFonts(site) {
  let font = ["Roboto:300,400,700", "sans-serif"];

  const fonts = {
    fiberdeck: ["Open Sans:300,400,700", "sans-serif"],
    felixwood: ["Poppins:300,400,700", "sans-serif"],
    felixdistribution: ["Poppins:300,400,700", "sans-serif"],
    cobrafastener: ["Fira Sans:300,400,700", "sans-serif"],
  };

  if (site in fonts) {
    font = fonts[site];
  }

  WebFont.load({
    google: {
      families: font,
    },
  });
}
